export default __webpack_public_path__ + "static/media/Offmyyard_Loader_img.2edf5c58.png";